// @core/api/endpoints/license/get_violations.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetViolationsResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Get license violations
 * Returns current license limit violations including user limits, storage limits, and product-specific violations with their severity.
 */
export async function GetViolations(
  license_id: string,
  options?: RequestOptions
): Promise<GetViolationsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/licenses/:license_id/violations`;
  requestPath = requestPath.replace(':license_id', encodeURIComponent(license_id));
  const requestOptions = options;
  return client.get<GetViolationsResponse>(requestPath, { ...requestOptions });
}
